'use client';

import { Stack, Text } from '@pie/amber';

/** Payment Acknowledgment block (verbatim from the mock). */
export const PAYMENT_ACKNOWLEDGMENT_HEADING = 'Payment Acknowledgment';
export const PAYMENT_ACKNOWLEDGMENT_BODY =
  'By submitting this payment method, I authorize Pie to charge this account for all ' +
  'amounts due until I update my payment method. If payments are handled by a third party ' +
  'or payroll provider, their terms and schedule apply instead. Premiums include applicable ' +
  'taxes and fees. A fee of up to $15 applies to each installment after the first. A $30 late ' +
  'fee may apply where permitted. If your policy is canceled early you may be subject to a ' +
  'charge depending on the cancellation reason. See your policy for details.';

/**
 * Static, display-only Payment Acknowledgment shown above the submit button.
 * Consent is implicit on submit — there is no checkbox (per spec + mock).
 */
export const PaymentAcknowledgment = () => (
  <Stack gap="2xs">
    <Text as="b" variant="body-sm">
      {PAYMENT_ACKNOWLEDGMENT_HEADING}
    </Text>
    <Text emphasis="subtle" variant="body-xs">
      {PAYMENT_ACKNOWLEDGMENT_BODY}
    </Text>
  </Stack>
);
